import { SVGProps } from '@components/Icon/types';

export const TennisBall = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M8 1C4.13549 1 1 4.13549 1 8C1 11.8645 4.13549 15 8 15C11.8645 15 15 11.8645 15 8C15 4.13549 11.8645 1 8 1ZM8 1.6087C8.02593 1.6087 8.05142 1.61017 8.07728 1.61048C8.0277 1.90709 8 2.21134 8 2.52174C8 5.54533 10.4547 8 13.4783 8C13.7887 8 14.0929 7.9723 14.3895 7.92272C14.3898 7.94858 14.3913 7.97407 14.3913 8C14.3913 11.536 11.536 14.3913 8 14.3913C7.97407 14.3913 7.94858 14.3898 7.92272 14.3895C7.9723 14.0929 8 13.7887 8 13.4783C8 10.4547 5.54533 8 2.52174 8C2.21134 8 1.90709 8.0277 1.61048 8.07728C1.61017 8.05142 1.6087 8.02593 1.6087 8C1.6087 4.46399 4.46399 1.6087 8 1.6087ZM8.68775 1.64555C11.6729 1.96346 14.0365 4.32709 14.3544 7.31224C14.0702 7.36382 13.7778 7.3913 13.4783 7.3913C10.7832 7.3913 8.6087 5.21685 8.6087 2.52174C8.6087 2.22215 8.63618 1.92975 8.68775 1.64555ZM2.52174 8.6087C5.21685 8.6087 7.3913 10.7832 7.3913 13.4783C7.3913 13.7778 7.36382 14.0702 7.31224 14.3544C4.32709 14.0365 1.96346 11.6729 1.64555 8.68775C1.92975 8.63618 2.22215 8.6087 2.52174 8.6087Z"
      fill={fill}
      stroke={fill}
      strokeWidth={0.6}
    />
  </svg>
);

export const ICON_NAME = 'tennis-ball';
